export default {"src":"/_next/static/media/naik.aaf92b87.svg","height":267,"width":267,"blurWidth":0,"blurHeight":0};